module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG59d351f29ca539417604e455bb4f7d21.59d351f2.png";